import React from "react";
import Headline from "./Headline";
import HomeLink from "../../widgets/HomeLink";

const bannerPath = '/iceholidays-assets/images/gd_flight_cover_latest.png';
const breadcrumbs = [
  { title: <HomeLink/>},
  { title: 'GD Flight About Us' }
] 

const GDFlightAboutPage = () => (
  <div id="about-us-page" className="more-page">
    <Headline showSearch={false} bannerImage={bannerPath} breadcrumbs={breadcrumbs} title="GD Flight About Us"/>

    <div className="more-page_body">
      <div className="more-page_content">
        <div id="article">
          <div id="article_image">
            <img src="/iceholidays-assets/images/gd_flight_about_us.jpg"/>
          </div>
          
        </div>

       
      </div>

    </div>
  </div>
);

export default GDFlightAboutPage;